"use client";
import o, { useRef as c } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import d from "./index.es42.js";
import f from "./index.es43.js";
const L = ({
  regionsData: i,
  regionSelection: m,
  compareScope: p,
  distributionExplanation: e,
  details: a,
  indicators: l,
  hash: n,
  fetchDistribution: s
}) => {
  const t = c(null);
  return d(t, n), /* @__PURE__ */ o.createElement("div", { ref: t }, l?.map((r) => /* @__PURE__ */ o.createElement(
    f,
    {
      key: `indicator-details-${r?.indicatorApiId}`,
      compareScope: p,
      fetchDistribution: s,
      indicator: r,
      monitorDetails: a,
      regionSelection: m,
      regionsData: i,
      distributionExplanation: e
    }
  )));
};
export {
  L as default
};
//# sourceMappingURL=index.es34.js.map
